import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'mediaFileFilter'
})
export class MedialFilterPipe implements PipeTransform {
  transform(items: any[], searchText: any[]): any {
    if (!items) {
      return;
    }

    if (searchText.length > 0) {
      if (searchText[1] === 'return-exist') {
        if (items && items.length > 0) {
          return items.filter(item => item.mime && item.mime.indexOf(searchText[0]) >= 0);
        } else {
          return (items['type'] && items['type'].indexOf(searchText[0]) >= 0 ) ? [items] : [];
        }
      }

      if (searchText[1] === 'return-file') {
        if (items.length > 0) {
          return items.filter(item => item.mime && item.mime.indexOf(searchText[0]) >= 0)
            ? items.filter(m => m.mime && m.mime.indexOf(searchText[0]) >= 0)[0] : false;
        } else {
          return (items['type'] && items['type'].indexOf(searchText[0]) >= 0) ? items : false;
        }
      }
    } else {
      return items.filter(item => item.mime && item.mime.indexOf(searchText) >= 0);
    }
  }
}
